<app-walks *ngIf="walksData" [walksData]="walksData"></app-walks>
<app-deals *ngIf="dealsData" [dealsData]="dealsData"></app-deals>
